export const SaveAs = {
  "Title": "Save As",
  "FileName": "File name:",
  "SaveType": "Save type:",
  "SettingsBtn": "Settings",
  "SharePoint": "Source Path",
  "LocalComputer": "Local Computer",
  "OneDrive": "OneDrive",
  "Box": "Box",
  "DropBox": "Dropbox",
  "GoogleDrive": "Google Drive",
  "iManage": "iManage 10",
  "Documents": "Cloud Documents",
  "Settings": {
    "Title": "Save As {title} Settings",
    "RestoreDefaults": "Restore Defaults",
    "ImageUnchangedInfo": "Images that already have {type} compression will be left unchanged.",
    "None": "None",
    "PageRange": "Page Range",
    "AllPages": "All pages",
    "Pages": "Pages: ",
    "Sample": "Sample: 1,5-9,12",
    "Subset": "Subset: ",
    "AllPagesInRange": "All pages in range",
    "EvenPagesOnly": "Even pages only",
    "OddPagesOnly": "Odd pages only",
    "pageRangeWarning": "No page is selected. Please select appropriate options.",
    "FileSetting": "File setting",
    "Interlace": "Interlace: ",
    "Grayscale": "Grayscale: ",
    "Color": "Color: ",
    "QualityLevel": "{type} (Quality: {level})",
    "Minimum": "Minimum",
    "Low": "Low",
    "Medium": "Medium",
    "High": "High",
    "Maximum": "Maximum",
    "TileSize": "Tile Size: ",
    "Pixels": "Pixels",
    "Monochrome": "Monochrome: ",
    "Conversion": "Conversion",
    "Colorspace": "Colorspace: ",
    "ColorOption": "Color",
    "GrayscaleOption": "Grayscale",
    "MonochromeOption": "Monochrome",
    "Resolution": "Resolution: ",
    "DetermineAutomatically": "Determine automatically",
    "PixelsInch": "pixels/inch",
    "Type": "Type: ",
    "SingleFile": "Single file",
    "MultipleFiles": "Multiple files",
    "Extraction": "Extraction",
    "ExcludeSmallerThan": "Exclude images smaller than: ",
    "NoLimit": "No limit",
    "Inches": "Inches",
    "ExportEngineSettings": "Export Engine Settings",
    "TextBasedDocument": "Text-based document",
    "TextBasedDocumentInfo": "A document primarily composed of text.",
    "ImageBasedDocument": "Image-based document",
    "ImageBasedDocumentInfo": "A document primarily composed of images and non-text objects.",
    "SetLanguages": "Set Languages",
    "ContentSettings": "Content Settings",
    "IncludeComments": "Include Comments",
    "IncludeImages": "Include Images",
    "LayoutSettings": "Layout Settings",
    "RetainFlowingText": "Retain flowing text",
    "RetainPageLayout": "Retain page layout",
    "NumericSettings": "Numeric Settings",
    "AutoDetectDecimal": "Auto detect decimal and thousands separators",
    "TreatTheFollowDecimal": "Treat the following as decimal and thousands separators",
    "DecimalSymbol": "Decimal Symbol",
    "ThousandsSeparator": "Thousands Separator",
    "ExcelWorkbookSettings": "Excel Workbook Settings",
    "CreateSingleWorksheet": "Create single Worksheet for the document",
    "CreateWorksheetEachTable": "Create Worksheet for each table",
    "CreateWorksheetEachPage": "Create Worksheet for each page",
    "FileAndNavigationPaneSettings": "File and Navigation Pane Settings",
    "SingleHtmlPage": "Single HTML Page",
    "AddHeadingsBased": "Add Headings-based Navigation frame",
    "AddBookmarksBased": "Add Bookmarks-based Navigation frame",
    "MultipleHtmlPage": "Multiple HTML Page",
    "SplitDocumentHeadings": "Split by Document Headings",
    "SplitDocumentBookmarks": "Split by Document Bookmarks",
    "LanguageSetting": {
      "ok": "OK",
      "Language": "Languages",
      "Title": "Language Settings",
      "LanguageDes": "Current language(s) used for exporting",
      "Languages": {
        "Arabic": "Arabic",
        "Basque": "Basque",
        "Bulgarian": "Bulgarian",
        "Catalan": "Catalan",
        "Chinese-Simplified": "Chinese-Simplified",
        "Chinese-Traditional": "Chinese-Traditional",
        "Croatian": "Croatian",
        "Czech": "Czech",
        "Danish": "Danish",
        "Dutch": "Dutch",
        "English": "English",
        "Estonian": "Estonian",
        "Faeroese": "Faeroese",
        "Finnish": "Finnish",
        "French": "French",
        "Galician": "Galician",
        "German": "German",
        "Greek": "Greek",
        "Hebrew": "Hebrew",
        "Hungarian": "Hungarian",
        "Icelandic": "Icelandic",
        "Italian": "Italian",
        "Japanese": "Japanese",
        "Korean": "Korean",
        "Latvian": "Latvian (Lettish)",
        "Lithuanian": "Lithuanian",
        "Macedonian": "Macedonian",
        "Maltese": "Maltese",
        "Norwegian": "Norwegian",
        "Polish": "Polish",
        "Portuguese": "Portuguese",
        "Romanian": "Romanian",
        "Russian": "Russian",
        "Serbian": "Serbian",
        "Slovak": "Slovak",
        "Slovenian": "Slovenian",
        "Spanish": "Spanish",
        "Swedish": "Swedish",
        "Thai": "Thai",
        "Turkish": "Turkish",
        "Ukrainian": "Ukrainian"
      }
    }
  }
}